export default "__VITE_ASSET__ff3bc845__"